const clientID = import.meta.env.VITE_ADOBE_SDK_CID;

const viewerConfig = {
	embedMode: "LIGHT_BOX",
};

export function lightbox(file, name) {
	const adobeDCView = new AdobeDC.View({
		clientId: clientID,
	});

	adobeDCView.previewFile(
		{
			content: {
				location: {
					url: file,
				},
			},
			metaData: {
				fileName: name.toString(),
			},
		},
		viewerConfig,
	);
}

export function createPreview(file, name, options, divId) {
	const adobeDCView = new AdobeDC.View({
		clientId: clientID,
		divId: divId,
	});

	adobeDCView.previewFile(
		{
			content: {
				location: {
					url: file,
				},
			},
			metaData: {
				fileName: name.toString(),
			},
		},
		options ?? viewerConfig,
	);
}
